import { DatePicker } from "antd";
import styles from "./DatePickerInput.module.css";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import TextComponent from "../textComponent/TextComponent";
import { GrFormClose } from "react-icons/gr";

const DatePickerInput = ({
  onChange,
  inputWidth,
  label,
  icon,
  format,
  placeholder,
  value,
  dateFormat,
  defaultValue,
  disabledDate,
  className,
  datePickerClass,
}) => {
  const { height, width } = useWindowDimensions();
  return (
    <div
      className={`${styles.datePicker} ${className}`}
      style={{ width: width > 576 ? inputWidth : "100%" }}
    >
      <text className={styles.label}>
        <TextComponent>{label}</TextComponent>
      </text>
      <DatePicker
      disabledDate={disabledDate}
        onChange={onChange}
        value={value}
        defaultValue={defaultValue}
        placeholder={placeholder}
        picker={format}
        suffixIcon={icon}
        className={`${styles.datePickerInput} ${datePickerClass}`}
        format={format == "month" ? "MM-YYYY" : "MM-DD-YYYY"}
        inputReadOnly
        clearIcon={
          <div className={styles.clearIconBtn}>
            <GrFormClose className={styles.clearIcon} />
          </div>
        }
      />
    </div>
  );
};

export default DatePickerInput;
